import toast from 'react-hot-toast';
import axiosInstance from 'services/axiosMiddleware';

export async function sendReport(reportData) {
  console.log('reportData', reportData);
  try {
    const response = await axiosInstance.post('report/createReport', reportData);
    return response.data;
  } catch (error) {
    console.error('Error adding report data:', error);
    throw error;
  }
}
